export default {
  maillog: {
    default: "Notification | Notifications",
    title: "Les notifications",
    list: {
      page_title: "Liste des notifications"
    },
    show: {
      page_title: "Notification :"
    },
    resendEmail: {
      title: "Réenvoyer l'email",
      label: "Email",
      placeholder: "Pour saisir plusieurs adresses, les séparer par \";\"",
      success: "L'email a été envoyé à {email}",
      error: "Une erreur est survenue. Veuillez contacter l'administrateur",
      noEmail: "Veuillez saisir une adresse email"
    }
  }
}
